module.exports = __webpack_public_path__ + "static/media/default-avatar.ba74413d.svg";